import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, switchMap } from 'rxjs';
import { LocationComposite } from '@lib.core/entities/location/location-composite.entity';
import { LocationCompositeResource } from '@lib.resources/location/location-composite.resource';
import { getHttpParams } from '@lib.resources/utils/url';
import { ResourceRegistry } from '@lib.resources/resource-registry/resource-registry';
import { EnvironmentResource } from '@lib.resources/environment/resource';
import { LocationCompositeDto, newLocationCompositeEntityFromDtos } from '@lib.resources/location/dtos/location-composite';


@Service()
export class LocationCompositeApiService implements LocationCompositeResource {

  private readonly http = inject(HttpClient);
  private readonly resourceRegistry = inject(ResourceRegistry);
  private readonly envResource$ = this.resourceRegistry.getEnvironmentResource();

  getLocationComposite(locationId: string, clientId: string): Observable<LocationComposite> {
    const params = getHttpParams({ clientSubdomain: clientId });
    return this.envResource$.pipe(
      switchMap((envResource: EnvironmentResource) => {
        const url = `${envResource.getBaseUrl()}/custom-locations/${locationId}/children`;
        return this.http.get<LocationCompositeDto[]>(url, { params });
      }),
      map((dtoList: LocationCompositeDto[]) => {
        const [entity, err] = newLocationCompositeEntityFromDtos(dtoList, locationId);
        if (err !== null) {
          throw err;
        }
        return entity!;
      })
    );
  }
}
